import { render, staticRenderFns } from "./ReloadConfirm.vue?vue&type=template&id=0c8e8179"
import script from "./ReloadConfirm.vue?vue&type=script&lang=js"
export * from "./ReloadConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports